<template>
  <div>
    <div class="my-home-content2">
      <h2>丰富、可行的信息化、智能化、智慧化解决方案</h2>
      <span class="span11">Rich and feasible information, intelligent and intelligent solutions</span>
      <router-link :to="{path:'solution'}">
        <span class="span22" @click="go()">查看更多解决方案></span>
      </router-link>
    </div>
    <div>
      <Row>
        <Col span="2"></Col>
        <Col span="21">
          <div>
            <Carousel />
          </div>
        </Col>
        <!-- <Col span="2"></Col> -->
      </Row>
      <a href="#threePage">
        <div>
          <Arrow/>
        </div>
      </a>
      <a name="threePage"></a>
    </div>
  </div>

</template>


<script>
    import Carousel from "@/util/Carousel.vue"
    import Arrow from '@/pages/components/Arrow'
    export default {
      name: 'HomeContent2',
      components:{Carousel,Arrow},
      methods:{
        go(){
          this.resetSetItem('index','2');
        }
      }
    }
</script>

<style>
    .my-home-content2{
      text-align: center;
      margin-bottom: 1rem;
      margin-top: 0.5rem;
    }
    .my-home-content2 h2{
      font-size: 0.25rem;
      margin-bottom: 0.25rem;
      letter-spacing:0.02rem;
	font-family: Nowar-CC-Warcraft-CN-Bold;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
    }
    .span11{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
    }
    .span22{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/pages/home-content/HomeContent2.vue